<template>
    <div style="width: 100%;height:100%;text-align: center;">
        <a-carousel :height="height+'px'" :trigger="option.attribute.trigger">
            <div v-for="item in option.attribute.imgUrls" :key="item">
                <img style="width: 100%; height: 100%" :src="item" :fit="option.attribute.fit"/>
            </div>
        </a-carousel>
    </div>
</template>

<script>
export default {
    name: "cpt-carousel",
    props: {
        height: {type: Number, default: 168},
        option: Object
    }
}
</script>

<style scoped>
</style>
